import React from "react";
import { Outlet } from "react-router";

const DarkLayout = () => {
  return (
    <div className="dark-layout">
      <Outlet />
    </div>
  );
};

export default DarkLayout;
